import React from 'react'
import { browserHistory } from 'react-router'
import { modal } from '../../../core/utilities/modal'
import { adminSubscriptions } from '../../../core/controllers/Admin/AdminSubscriptions';

import UsersSelect from '../../Admin/Users/UsersSelect'

export default class SubscriptionEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            subscriptionId : props.subscriptionId,
            name: '',
            price: '',
            user_id: 0
        };
    }

    componentDidMount() {
        var self = this;
        if(!this.props.newSubscription) {
            adminSubscriptions.getSubscription(this.props.subscriptionId,function(response) {
                self.setState({
                    name: response.data.name,
                    price: response.data.price
                });
            });
        }
    }

    handleNameChange(e) {
        this.setState({
            name: e.target.value
        });
    }

    handlePriceChange(e) {
        this.setState({
            price: e.target.value
        });
    }

    updateSubscription(e) {
        if(!this.validateData()){
            return;
        }
        adminSubscriptions.updateSubscription(this.state.subscriptionId, this.state.name, this.state.price, this.state.user_id, function(response) {
            modal.showInfo("Subscription has been updated.", "success", "top", "center");
        });
    }

    deleteSubscription(e) {
        adminSubscriptions.deleteSubscription(this.state.subscriptionId, function(response) {
            modal.showInfo("Subscription has been deleted.", "success", "top", "center");
            browserHistory.goBack();
        });
    }

    saveSubscription(e) {
        var self = this;
        if(!this.validateData()){
            return;
        }
        adminSubscriptions.saveSubscription(this.state.name, this.state.price, function(response) {
            if (response.status && response.status == 'OK') {
                if (self.props.newSubscription) {
                    browserHistory.goBack();
                    modal.showInfo("Subscription has been created.", "success", "top", "center");
                }
            }
        });
    }

    validateData() {
        const name = this.state.name;
        const price = this.state.price;

        if(name.length == 0) {
            modal.showInfo("You need to enter a name.", "danger", "top", "center");
            return false;
        }

        if(price.length == 0) {
            modal.showInfo("You need to enter a price.", "danger", "top", "center");
            return false;
        }

        if (this.state.newSubscription) {
            //new account conditions
        }

        return true;
    }

    handleUserAssign(e) {
        this.setState({
            user_id: e.target.value
        })
    }

    render(){
        const newSubscription = this.props.newSubscription;
        const name = this.state.name;
        const price = this.state.price;
        const user_id = this.state.user_id;
        var buttonText = 'Update Subscription';
        var userFunc = this.updateSubscription.bind(this);
        if (newSubscription) {
            buttonText = 'Create Subscription';
            userFunc = this.saveSubscription.bind(this);
        }

        return (
        <div>
        <div class="row blue-bottom-margin">
            {newSubscription ? (
            <div class="row">
                <div class="sub-page-header-row col-md-11">
                    <div class="row">
                        <span class="sub-page-header-title">Add a Subscription</span>
                    </div>
                </div>
            </div>
            ) : (
            <div class="row">
                <div class="sub-page-header-row col-md-11">
                    <div class="row">
                        <span class="sub-page-header-title">{name} - ${price / 100}</span>
                    </div>
                </div>
            </div>
            )}
            <div class="col-md-12">
                <div class="card">
                    <div class="header">
                        <h4 class="title">Subscription Information</h4>
                        <p class="category"></p>
                    </div>
                    <div class="content">
                        <form>
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Name</label>
                                        <input type="text" class="form-control tenant-info" name="name" placeholder="Primary" id="name" value={name} onChange={this.handleNameChange.bind(this)}/>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Price</label>
                                        <input type="text" class="form-control tenant-info" value={price} name="price" placeholder="$40.00" id="price" onChange={this.handlePriceChange.bind(this)}/>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="card">
                    <div class="header">
                        <h4 class="title">Subscribe User</h4>
                        <p class="category"></p>
                    </div>
                    <div class="content">
                        <div class="row">
                            <div class="col-md-5 col-sm-6 col-xs-12">
                                <div class="form-group">
                                    <label for="ordertype">Assign User</label>
                                    <div class="clearfix"></div>
                                    <UsersSelect disabled={false} columnSize={0} title="" accountType="contractor" sortID={user_id} onChange={this.handleUserAssign.bind(this)}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row blue-bottom">
            <div class="blue-bottom-center-align">
                { newSubscription === false ? (
                    <div>
                        <div class="col-md-6 col-sm-6 col-xs-12 blue-bottom-btn-right-push">
                            <button type="button" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill" autoComplete="off" onClick={this.deleteSubscription.bind(this)}>
                            Delete Subscription
                            </button>
                        </div>
                        <div class="col-md-3 col-sm-6 col-xs-12">
                            <button type="button" id="save-user" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off" onClick={this.updateSubscription.bind(this)}>
                            {buttonText}
                            </button>
                        </div>
                    </div>
                ) : (
                    <div class="col-md-12">
                        <button type="button" id="create-user" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off" onClick={userFunc}>
                        {buttonText}
                        </button>
                    </div>
                )}
                <div class="clearfix"></div>
            </div>
        </div>
        </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Admin/Subscription/SubscriptionEdit.jsx